import _ from 'lodash'
import config from 'scoreboard/components/config'
import i18n from 'scoreboard/components/i18n'
import unwrapModel from 'scoreboard/components/unwrap-model'
import fieldAggregationDescription from 'scoreboard/datasets/field-aggregation-description'
import initiativeCalculationTypes from 'scoreboard/initiatives/initiative-calculation-types'
import replacePlaceholders from 'scoreboard/templates/replace-placeholders'

function serieLabel ({ serie, domainData }) {
	let source = serie.get('source')
	let customLabel = serie.get('label')

	let domainType = source.domainType

	let defaultLabel, domainObject, dataProperty
	if (domainType === 'dataset') {
		let dataset = domainData.datasetModel(source.aggregation.startingDatasetId)

		let opt = {
			dataset,
			aggregationType: source.aggregation.aggregationType
		}
		if (dataset) {
			opt.tracked = dataset.get('tracked')
		}

		if (source.aggregation.dataSourceType === 'basic') {
			if (dataset) {
				_.extend(opt, {
					aggregationField: dataset.combinedFieldsById[source.aggregation.fieldId],
					aggregationVisibleLinkedField: dataset.visibleLinkedFieldsById[
						source.datasetVisibleLinkedFieldId]
				})
			}
		} else {
			opt.equation = source.aggregation.equation
		}

		defaultLabel = fieldAggregationDescription(opt)
		domainObject = unwrapModel(dataset)
		// #42143 the old "series name" column in v4 dataset series was the same
		// as the "Field Name and Aggregation Type" autogenerated series name option
		dataProperty = defaultLabel
	} else if (domainType === 'scorecard-item') {
		domainObject = domainData.scorecards(source.scorecardItemId)
		defaultLabel = domainObject.label
		dataProperty = scorecardDataPropertyLabel({ scorecardItem: domainObject, source })
	} else if (domainType === 'initiative') {
		domainObject = domainData.initiatives(source.initiativeId)
		defaultLabel = domainObject.label
		dataProperty = i18n.get(initiativeCalculationTypes.messageCode(source.dataProperty))
	}

	if (customLabel) {
		let orgLabel = null
		if (domainObject && domainObject.organizationId) {
			orgLabel = _.get(domainData.organizations(domainObject.organizationId), 'label')
		}

		let replacements = [
			{ placeholder: 'source-item-organization', value: orgLabel },
			{ placeholder: 'source-item-name', value: defaultLabel },
			{ placeholder: 'source-item-field', value: dataProperty }
		]
		return replacePlaceholders(customLabel, replacements, { plainText: true })
	} else {
		return defaultLabel
	}

	throw new Error(`no support for domainType ${domainType} implemented yet`)
}

function scorecardDataPropertyLabel ({ scorecardItem, source }) {
	switch (source.dataProperty) {
		case 'value': return i18n.get('scorecards.node.metric.actualValue')
		case 'score': return i18n.get('scorecards.node.score')
		case 'threshold': {
			let scoringType = config.scoringType(scorecardItem.scoringTypeId)
			return i18n.get(scoringType.thresholdNames[source.thresholdIndex])
		}
	}
}

export default serieLabel

serieLabel.__filename__ = 'charts/serie-label.js'
